import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Table } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 20
    },
    headerStyle: {
        borderRightStyle: 'solid', 
        borderRightColor: "#424242",
        
    },
    headerBackground: {
        backgroundColor: '#212121'
    },
    sumBackground: {
        backgroundColor: '#212121',
        padding: 10,
        textAlign: 'center'
    },
    sumStyle: {
        fontSize: "1.2rem",
    }
}));

function ReportRes() {
    const classes = useStyles();
    const {t} = useTranslation('scanReport');

    const scanReportManagement = useSelector(state => state.scanReportReducer);

    const [blindRes, setBlindRes] = useState([]);
    const [normalRes, setNormalRes] = useState([]);
    const [expandedBlindBatches, setExpandedBlindBatches] = useState(false);
    const [expandedNormalBatches, setExpandedNormalBatches] = useState(false);

    const blindColumns = [
        t('blind_batch_scan_rate'),
        t('blind_batch_total_scanned')
    ]

    const handleChangeBlindBatches = (panel) => (event, isExpanded) => {
        setExpandedBlindBatches(isExpanded ? panel : false);
    };
    const handleChangeNormalBatches = (panel) => (event, isExpanded) => {
        setExpandedNormalBatches(isExpanded ? panel : false);
    };

    useEffect(() => {
        if(scanReportManagement.getBlindScan) {
            if(scanReportManagement.getBlindScan.blindResult) {               
                setBlindRes(scanReportManagement.getBlindScan.blindResult);
            }
            if(scanReportManagement.getBlindScan.normalResult) {
                setNormalRes(scanReportManagement.getBlindScan.normalResult);
            }
        }
    }, [scanReportManagement.getBlindScan])

    return (
        <div className={classes.container}>
            {
            Object.keys(blindRes).length > 0 && <Accordion expanded={expandedBlindBatches === 'panel1'} onChange={handleChangeBlindBatches('panel1')}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className={ classes.flexCount }
                >
                    {
                        Object.keys(blindRes).length > 0 && 
                        <div>
                            <span className={classes.sumStyle}>{t('blind_scanned_sum')}</span>
                            <span className={classes.sumStyle}>{blindRes['blind_scanned_sum']}</span>
                        </div>
                    }
                </AccordionSummary>
                <AccordionDetails>
                {
                    Object.keys(blindRes).length > 0 && 
                    <Table style={{ marginTop: 20 }}>
                        <TableHead className={classes.headerBackground}>
                            <TableRow>
                                <TableCell align="center" className={classes.headerStyle}>{t('blind_batch')}</TableCell>
                                {
                                    blindColumns.map((column) => {
                                        return (
                                            <TableCell align="center" className={classes.headerStyle}>{column}</TableCell>                                        
                                        );
                                    })
                                }
                            </TableRow>    
                        </TableHead>
                        <TableBody>
                            {
                                Object.keys(blindRes).map((batch) => {
                                    if(batch === 'blind_scanned_sum') {
                                        return;
                                    }                            
                                    return (
                                        <TableRow>
                                            <TableCell align="center">{batch}</TableCell>
                                            <TableCell align="center">{blindRes[batch]['blind_batch_scan_rate']}</TableCell>
                                            <TableCell align="center">{blindRes[batch]['blind_batch_total_scanned']}</TableCell>
                                        </TableRow>  
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                }
                </AccordionDetails>
            </Accordion>
            }            
            {
            Object.keys(normalRes).length > 0 && <Accordion expanded={expandedNormalBatches === 'panel2'} onChange={handleChangeNormalBatches('panel2')} style={{ marginTop: 20 }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    className={ classes.flexCount }
                >
                    {
                    normalRes['normal_scanned_completion_rate_sum'] && 
                    <div>
                        <span className={classes.sumStyle}>{t('normal_scanned_completion_rate_sum')}</span>
                        <span className={classes.sumStyle}>{normalRes['normal_scanned_completion_rate_sum']}</span>
                    </div>
                    }
                </AccordionSummary>
                <AccordionDetails className={classes.container}>
                {
                    normalRes && Object.keys(normalRes).map((batch) => {
                        if(batch === 'normal_scanned_completion_rate_sum') {
                            return;
                        }
                        return (
                            <div>
                                <div style={{ marginTop: 20 }}>{t('normal_batch')}{batch}</div>
                                <Table style={{ marginTop: 10 }}>
                                    <TableHead className={classes.headerBackground}>
                                        <TableRow>
                                            <TableCell align="center" className={classes.headerStyle}>{t('normal_batch_scan_completion_rate')}</TableCell>
                                            {
                                                normalRes[batch]['overall_stats'] && normalRes[batch]['overall_stats'].map((column) => {
                                                    return <TableCell align="center" className={classes.headerStyle}>{column.pathInfo}</TableCell>
                                                })
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {   normalRes[batch]['Normal_batch_scan_completion_rate'] && 
                                            <TableCell align="center">{normalRes[batch]['Normal_batch_scan_completion_rate']}</TableCell>
                                        }
                                        {
                                            normalRes[batch]['overall_stats'] && normalRes[batch]['overall_stats'].map((column) => {
                                                return <TableCell align="center">{column.stats}</TableCell>
                                            })
                                        }
                                    </TableBody>                                   
                                </Table>
                            </div>                           
                        )
                    })
                }
                </AccordionDetails>
            </Accordion>
            }
        </div>
    );
}
export default ReportRes;